// extracted by mini-css-extract-plugin
export default {"sidebar":"uvrOa5","search-sidebar":"TURNWu"};